import {PageHeader, Dropdown, DropdownItem, EitjeButton, AdvancedTableOptions} from '~/components'
import {TABLE_INFO} from '~/components/advanced_table/instances/environments/constants'

export const EnvironmentsPageHeader = () => {
	return <PageHeader label="common.environments" right={[<AdvancedTableOptions key={0} {...TABLE_INFO} />, <Tools key={1} />]} />
}

const Tools = () => {
	return (
		<Dropdown trigger={<EitjeButton t="common.tools" height="small" iconRight="chevron-small-down" />}>
			<DropdownItem t="common.search" iconLeft="magnifying-glass" to="/search/firm" />
			<DropdownItem t="common.environment" iconLeft="plus" modalLink="/firms/environments/new" />
		</Dropdown>
	)
}
